<script>
  import { onDestroy } from 'svelte';
  import { modalFocus } from '../lib/modal.js';
  export let onCode; export let onClose;
  let scanner; let loading = false; let error = ''; let disposed = false;
  async function stop() { if (scanner?.isScanning) await scanner.stop(); }
  async function start() {
    loading = true; error = '';
    try {
      const { Html5Qrcode } = await import('html5-qrcode');
      if (disposed) return;
      scanner = new Html5Qrcode('scanner-region');
      await scanner.start({ facingMode: 'environment' }, { fps: 10, qrbox: { width: 250, height: 150 } }, async code => {
        if (disposed) return;
        disposed = true; await stop(); onCode(code); onClose();
      }, () => {});
      if (disposed) await stop();
    } catch (reason) { error = reason.message || String(reason); } finally { loading = false; }
  }
  onDestroy(() => { disposed = true; stop().catch(() => {}); });
</script>
<button class="drawer-backdrop receipt-backdrop" on:click={onClose} aria-label="Cerrar lector"></button>
<div class="receipt-dialog" use:modalFocus role="dialog" aria-modal="true" aria-label="Lector de cámara" tabindex="-1" on:keydown={event => { if (event.key === 'Escape') onClose(); }}><header class="section-heading"><h2>Escanear código</h2><button class="text-button" on:click={onClose}>Cerrar</button></header><div id="scanner-region"></div><button class="primary-action" disabled={loading || scanner?.isScanning} on:click={start}>{loading ? 'Iniciando…' : 'Activar cámara'}</button>{#if error}<p class="notice error" role="alert">{error}</p>{/if}</div>
